import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=325b0778"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('325b0778')) {
      api.createRecord('325b0778', component.options)
    } else {
      api.reload('325b0778', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=325b0778", function () {
      api.rerender('325b0778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/transfer/virtual/edit.vue"
export default component.exports